export default __webpack_public_path__ + "static/media/map_check_my places_mockup.e1d4bc0a.png";